/**
 * Padrão único de exibição de ausência em todas as tabelas do sistema.
 *
 * Coluna  -> "Ausência:100px"
 * Valor   -> número + "d" (ex.: 12d), com faixa de cor por risco
 * Vazio   -> "-"
 *
 * Faixas (mesmas do CRM Pet):
 *   até 15d  -> verde   (em dia)
 *   até 45d  -> âmbar   (atenção)
 *   acima    -> vermelho(risco)
 */

export const ABSENCE_RANGES = [
  { max: 15, className: "bg-emerald-50 text-emerald-700" },
  { max: 45, className: "bg-amber-50 text-amber-700" },
  { max: Infinity, className: "bg-red-50 text-red-600" },
];

export function AbsenceBadge({ days }) {
  const value = Number(days);

  if (days === null || days === undefined || days === "" || Number.isNaN(value)) {
    return <span className="text-gray-400">-</span>;
  }

  const { className } = ABSENCE_RANGES.find((range) => value <= range.max);

  return (
    <span
      className={`rounded-full px-2 py-1 text-xs font-semibold ${className}`}
      title={`${value} ${value === 1 ? "dia" : "dias"} sem agendamento`}
    >
      {value}d
    </span>
  );
}
